import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Injected by craco/webpack DefinePlugin at build time. Falls back to "dev"
// when running under hot-reload (where Define isn't applied to the runtime).
// eslint-disable-next-line no-undef
const FE_BUILD_TIME = typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : null;

const fmt = (iso) => {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    return d.toLocaleString('en-GB', {
      day: '2-digit', month: 'short', year: '2-digit',
      hour: '2-digit', minute: '2-digit',
    });
  } catch {
    return iso;
  }
};

/**
 * Small, muted footer showing frontend build time + backend deploy time.
 * Used for support triage: tells you at a glance whether a user is on a
 * stale JS bundle vs running against the latest backend.
 *
 * Tap to copy → users can paste the version string into a feedback message.
 */
const VersionFooter = () => {
  const [backendInfo, setBackendInfo] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API_URL}/api/version`)
      .then(({ data }) => {
        if (!cancelled) setBackendInfo(data);
      })
      .catch(() => {
        // Silent — version footer is best-effort
      });
    return () => { cancelled = true; };
  }, []);

  const versionString =
    `FE: ${fmt(FE_BUILD_TIME)} · BE: ${fmt(backendInfo?.backend_deployed_at)}`;

  const handleCopy = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(versionString).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      }).catch(() => { /* private mode etc. */ });
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      title={`Tap to copy version info\n\nFrontend built: ${fmt(FE_BUILD_TIME)}\nBackend deployed: ${fmt(backendInfo?.backend_deployed_at)}`}
      className="w-full text-center mt-2 text-[9px] text-slate-600 hover:text-slate-400 transition-colors leading-tight select-text cursor-pointer"
      data-testid="version-footer"
      data-fe-build={FE_BUILD_TIME || ''}
      data-be-deployed={backendInfo?.backend_deployed_at || ''}
    >
      {copied ? (
        <span className="text-emerald-500">✓ Copied to clipboard</span>
      ) : (
        <span>
          <span className="block">FE {fmt(FE_BUILD_TIME)}</span>
          <span className="block">BE {fmt(backendInfo?.backend_deployed_at)}</span>
        </span>
      )}
    </button>
  );
};

export default VersionFooter;
